<template>
    <v-card>
        <v-card-text class="pb-1">
            <v-row>
                <v-col
                    class="px-0"
                    cols="3">
                    <date-range-field
                        class="mx-4"
                        v-model="pagination.dateRange"
                        @input="changedateRange"/>
                </v-col>
                <v-col
                    class="px-0"
                    cols="4">
                    <v-text-field
                        outlined
                        hide-details
                        height="40px"
                        append-icon="search"
                        v-model="pagination.search"
                        :placeholder="$t('placeholder.filterBySaleNameEmailAndPhone')"/>
                </v-col>
                <v-col cols="2">
                    <v-select
                        outlined
                        hide-details
                        v-model="pagination.type"
                        append-icon="expand_more"
                        height="40px"
                        item-value="value"
                        item-text="text"
                        v-on:change="changesubRoles"
                        :menu-props="{
                            offsetY: true
                        }"
                        :items="typeList"/>
                </v-col>
                <v-col cols="3">
                    <v-btn
                        class="font-weight-regular"
                        color="primary"
                        @click="getExportExcel">
                        <icon
                            class="mr-2"
                            value="file_download"
                            size="18px"/>
                        {{ $t('button.exportXlsx') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <sale-agent-table
                :search="pagination.search"
                :items="saleAgents"
                :options="pagination"
                :excludeHeaders="[
                    $constant.table.SALE_AGENT_KEY.isVerified,
                    $constant.table.SALE_AGENT_KEY.email,
                    $constant.table.SALE_AGENT_KEY.phonenumber,
                    $constant.table.SALE_AGENT_KEY.isActive,
                    $constant.table.SALE_AGENT_KEY.createdAt
                ]"
                @viewDetails="openSaleAgentPersonDetails"/>
        </v-card-text>

        <right-panel
            ref="saleAgentPersonDetails"
            :title="$t('saleAgent.saleAgentByPersonDetails')">
            <template v-slot:content="{ context }">
                <sale-agent-person-details-view
                    :saleAgent="context"/>
            </template>
            <!-- @click="onClickPanelSave" -->
            <template v-slot:bottom>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary"
                    @click="onClickPanelSave"
                >
                    {{ $t('button.save') }}
                </v-btn>
            </template>

        </right-panel>
    </v-card>
</template>

<script>
import DateRangeField from '@/components/fields/DateRangeField'
import SaleAgentTable from '@/components/tables/SaleAgentTable'
import RightPanel from '@/components/panels/RightPanel'
import SaleAgentPersonDetailsView from '@/views/SaleAgentPersonDetailsView'
import { mapState } from 'vuex'

export default {
    name: 'SaleAgentByPersonListView',

    components: {
        DateRangeField,
        SaleAgentTable,
        RightPanel,
        SaleAgentPersonDetailsView
    },

    props: {
        saleAgents: {
            type: Array,
            default: () => []
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        ...mapState('saleagentByPerson', ['orderlist'])
    },

    data () {
        return {
            typeList: [
                'ทุกประเภทตัวแทน',
                'Street Counter',
                'Taxi / Van',
                'Tour Agency',
                'Hotel Concierge'
            ],
            startDate: '',
            endDate: ''
        }
    },

    methods: {
        openSaleAgentPersonDetails (saleAgent) {
            const cloneSaleAgent = JSON.parse(JSON.stringify(saleAgent))
            this.$refs.saleAgentPersonDetails.open(cloneSaleAgent)
        },
        changedateRange (value) {
            const datestart = new Date(value[0])
            const dateend = new Date(value[1])
            const diffTime = Math.abs(dateend - datestart)
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
            if (diffDays > 30) {
                alert('กรุณาเลือกไม่เกิน 30 วัน')
                return
            }
            this.startDate = new Date(value[0]).toISOString()
            this.endDate = new Date(value[1]).toISOString()
            this.$store.commit('saleagentByPerson/setStartdate', new Date(value[0]).toISOString())
            this.$store.commit('saleagentByPerson/setEnddate', new Date(value[1]).toISOString())
            this.$store.dispatch('saleagentByPerson/fetchOrderlist')
        },
        onClickPanelSave () {
            // this.$refs.saleAgentPersonDetails.patchUpdate()
            this.$refs.saleAgentPersonDetails.close()
            this.$store.dispatch('saleagentByPerson/fetchOrderlist')
        },
        changesubRoles (value) {
            var optionData = {}
            if (value === 'ทุกประเภทตัวแทน') {
                optionData = {
                    roles: 'sales-agent',
                    isVerified: 'approve'
                }
            } else {
                optionData = {
                    roles: 'sales-agent',
                    isVerified: 'approve',
                    subRoles: value
                }
            }
            this.$store.commit('saleagentByPerson/setOption', optionData)
            this.$store.dispatch('saleagentByPerson/fetchOrderlist')
        },
        getExportExcel () {
            const url = process.env.VUE_APP_BASE_URL + `/export/sales-by-person?startDate=${this.startDate}&endDate=${this.endDate}&page=0&itemsPerPage=50&isVerified=approve&roles=sales-agent`
            // FileSaver.saveAs(blob, filename)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'filename')
            document.body.appendChild(link)
            link.click()
        }

    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-select {
    .v-select__selection {
        text-transform: capitalize;
    }
}
</style>
